/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './surgical-appointment.reducer';

export const SurgicalAppointmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surgicalAppointmentEntity = useAppSelector(state => state.surgicalAppointment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surgicalAppointmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surgicalAppointment.detail.title">SurgicalAppointment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.id">Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.id}</dd>
          <dt>
            <span id="actualStartTime">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.actualStartTime">Actual Start Time</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.actualStartTime}</dd>
          <dt>
            <span id="actualEndTime">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.actualEndTime">Actual End Time</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.actualEndTime}</dd>
          <dt>
            <span id="plannedStartTime">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.plannedStartTime">Planned Start Time</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.plannedStartTime}</dd>
          <dt>
            <span id="plannedEndTime">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.plannedEndTime">Planned End Time</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.plannedEndTime}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.status">Status</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.status}</dd>
          <dt>
            <span id="bookedDate">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.bookedDate">Booked Date</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.bookedDate}</dd>
          <dt>
            <span id="cancelledDate">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.cancelledDate">Cancelled Date</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.cancelledDate}</dd>
          <dt>
            <span id="bookedByType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.bookedByType">Booked By Type</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.bookedByType}</dd>
          <dt>
            <span id="bookedById">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.bookedById">Booked By Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.bookedById}</dd>
          <dt>
            <span id="cancelledByType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.cancelledByType">Cancelled By Type</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.cancelledByType}</dd>
          <dt>
            <span id="cancelledById">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.cancelledById">Cancelled By Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.cancelledById}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.active">Active</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.timestampentry}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.notes}</dd>
          <dt>
            <span id="considerOnArrival">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.considerOnArrival">Consider On Arrival</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentEntity.considerOnArrival}</dd>
          <dt>
            <span id="handedOverToId">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.handedOverToId">Handed Over To Id</Translate>
            </span>
            <UncontrolledTooltip target="handedOverToId">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.handedOverToId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{surgicalAppointmentEntity.handedOverToId}</dd>
          <dt>
            <span id="handedOverToType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.handedOverToType">Handed Over To Type</Translate>
            </span>
            <UncontrolledTooltip target="handedOverToType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.handedOverToType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{surgicalAppointmentEntity.handedOverToType}</dd>
          <dt>
            <span id="takenOverById">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.takenOverById">Taken Over By Id</Translate>
            </span>
            <UncontrolledTooltip target="takenOverById">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.takenOverById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{surgicalAppointmentEntity.takenOverById}</dd>
          <dt>
            <span id="takenOverByType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.takenOverByType">Taken Over By Type</Translate>
            </span>
            <UncontrolledTooltip target="takenOverByType">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointment.help.takenOverByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{surgicalAppointmentEntity.takenOverByType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointment.theatre">Theatre</Translate>
          </dt>
          <dd>{surgicalAppointmentEntity.theatre ? surgicalAppointmentEntity.theatre.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointment.surgery">Surgery</Translate>
          </dt>
          <dd>{surgicalAppointmentEntity.surgery ? surgicalAppointmentEntity.surgery.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/surgical-appointment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/surgical-appointment/${surgicalAppointmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurgicalAppointmentDetail;
